import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchActivityList } from '../api/activityApi';
import type { ActivityFilters } from '../types';

const PAGE_SIZE = 20;

export type { ActivityFilters } from '../types';

export function useActivityList(filters: ActivityFilters) {
  return useInfiniteQuery({
    queryKey: ['activity', filters],
    queryFn: ({ pageParam, signal }) =>
      fetchActivityList(filters, pageParam, PAGE_SIZE, signal),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      lastPage.hasMore
        ? allPages.reduce((sum, p) => sum + p.items.length, 0)
        : undefined,
    staleTime: 30000,
  });
}
